import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Allow updatePassword without token
    if (route.routeConfig?.path === "updatePassword") {
      return true;
    }
    // Otherwise require token
    if (!sessionStorage.getItem("invUIToken")) {
      this.router.navigate(["/login"]);
      return false;
    }
    return true;
  }
}
